import footerLogo from "../../assets/images/footer-logo.png";
import instagramLogo from "../../assets/images/instagram-logo.png";
import facebookLogo from "../../assets/images/facebook-logo.png";
import twitterLogo from "../../assets/images/twitter-logo.png";
import linkedinLogo from "../../assets/images/linkedin-logo.png";
import youtubeLogo from "../../assets/images/youtube-logo.png";

const Footer = () => {
  return (
    <section className="w-full flex justify-center py-10 bg-green-custom">
      <div className="w-4/5 max-w-screen-xl flex flex-col md:flex-row items-center justify-between space-y-6 md:space-y-0">
        <div>
          <a
            href="https://www.unilever.com.tr/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={footerLogo} alt="bizztrip logo" width="82" />
          </a>
        </div>
        <div>
          <ul className="flex flex-col md:flex-row space-x-0 space-y-3 md:space-y-0 md:space-x-24 text-center">
            <li className="text-white hover:text-yellow-400 text-base font-medium">
              <a
                href="https://www.unilever.com.tr/contact/"
                target="_blank"
                rel="noreferrer"
              >
                Contact Us
              </a>
            </li>
            <li className="text-white hover:text-yellow-400 text-base font-medium">
              <a href="/">Cookie Notice</a>
            </li>
            <li className="text-white hover:text-yellow-400 text-base font-medium">
              <a href="/">Privacy Notice</a>
            </li>
          </ul>
        </div>
        <div>
          <ul className="flex flex-row space-x-7">
            <li>
              <a href="https://twitter.com/ULCareersTR">
                <img src={twitterLogo} alt="bizz trip twitter" width="32" />
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/UnileverCareers/?brand_redir=407608389253146">
                <img src={facebookLogo} alt="bizz trip facebook" width="32" />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/unilever/">
                <img src={linkedinLogo} alt="bizz trip linkedin" width="32" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/unilevercareerstr/?hl=en">
                <img src={instagramLogo} alt="bizz trip instagram" width="32" />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/channel/UCMez3Fwt1o8pLlsABvYt1Jg">
                <img src={youtubeLogo} alt="bizz trip youtube" width="32" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Footer;
